<!--  -->
<template>
  <div>
    <div class="bg-top">
      <img :src="article.thumb_detail" alt="" />
    </div>
    <div class="content">
      <div class="details-box">
        <div class="img-box">
          <img src="./english.png" alt="" class="english" />
          <div class="box">
            <img src="./left.png" alt="" class="left" />
            <div class="title">{{ article.title }}</div>
            <img src="./right.png" alt="" class="right" />
          </div>
        </div>
        <div class="details">
          <div class="up">活动时间：</div>
          <div class="time">{{ moment(article.start_time * 1000).format("YYYY/MM/DD") }} - {{ moment(article.end_time * 1000).format("YYYY/MM/DD") }}</div>
          <div class="up">活动详情：</div>
          <div class="down" v-html="article.content"></div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { post } from "../../util/http";
import moment from "moment";
import Footer from "@/components/footer/footer";

export default {
  components: { Footer },
  data() {
    return {
      article: {},
      moment: moment,
    };
  },
  created() {},
  mounted() {
    this.getActivityDetailsList(this.$route.params.id);
  },
  computed: {},
  watch: {},
  methods: {
    async getActivityDetailsList(id) {
      const {
        data: { data },
      } = await post({
        url: "/api/activity/getActivityById",
        data: {
          id: parseInt(id),
        },
      });
      this.article = data;
    },
  },
};
</script>
<style lang='scss' scoped>
.bg-top {
  margin-top: 0.56rem;
  height: 3.4rem;
  img {
    width: 100%;
    height: 100%;
  }
}
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.24rem 0;
  background-color: #f4f5f8;
  .details-box {
    min-height: 4.8rem;
    width: 14rem;
    border-radius: 0.2rem 0.2rem 0 0;
    background-color: #fff;
    .img-box {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      position: relative;
      height: 1.39rem;
      .english {
        width: 5.8rem;
        height: 0.85rem;
        position: absolute;
        top: 0.1rem;
        left: 50%;
        transform: translateX(-50%);
        flex: 1;
      }
      .box {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: .2rem;
        .left {
          width: 5.32rem;
          height: 0.2rem;
          margin-right: .2rem;
        }
        .right {
          width: 5.32rem;
          height: 0.2rem;
          margin-left: .2rem;
        }
        .title {
          flex: 1;
          line-height: 0.4rem;
          letter-spacing: 0.06rem;
          font-size: 0.32rem;
          font-weight: 900;
          color: #02a8a2;
        }
      }
    }
  }
  .details {
    padding: 0 0.85rem;
    font-size: 0.14rem;
    color: #666;
    .up {
      font-size: 0.24rem;
      font-weight: 500;
      color: #333;
    }
    .time {
      margin: 0.2rem 0 0.5rem 0;
      font-size: 0.18rem;
    }
    .down {
      margin: 0.2rem 0 0.78rem 0;
    }
  }
}
</style>